import React from 'react'
import { Button } from '@material-ui/core'
import './BackButton.scss'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import { EventEmitterService, EventKey } from '../../../services/EventEmitterService'

export const BackButton = props => {
  const flowGoBack = () => {
    EventEmitterService.dispatch(EventKey.FLOW_GO_BACK)
  }

  return (
    <Button
      onClick={flowGoBack}
      {...props}
      variant="contained"
      startIcon={<KeyboardBackspaceIcon />}
      disableElevation
      className="back-button-flow"
    >
      Back
    </Button>
  )
}
